import React, { useState, useEffect, useContext } from 'react';
import api from '../utils/api';
import InventoryListPopup from './InventoryListPopup';
import './styles/TransferInventoryPage.css';
import { BsFiles } from "react-icons/bs";
import { MdDelete } from "react-icons/md";
import { useNavigate } from 'react-router-dom'; 
import AuthContext from '../context/AuthContext';

const StockTransferPage = () => {
    const { user } = useContext(AuthContext);
    const [selectedItem, setSelectedItem] = useState(null);
    const [branchList, setBranchList] = useState([]);
    const [amount, setAmount] = useState('');
    const [branch, setBranch] = useState('');
    const [receiver, setReceiver] = useState(null);
    const [items, setItems] = useState([]);
    const [showInventoryPopup, setShowInventoryPopup] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        const fetchBranchList = async () => {
            try {
                const response = await api.get('/utils/getBranchList');
                const branches = response.data.data.branchList.map(branch => ({
                    id: branch.branch_id,
                    name: `${branch.branch_code} - ${branch.branch_name}`,
                }));
                setBranchList(branches);


            } catch (error) {
                console.error("Failed to fetch branch list", error);
            }
        };

        fetchBranchList();

        
        
    }, []);

    useEffect(() => {
        api.post('/teacher/getTeacher', {
            data: {
                username: user.username
            }
        })
        .then(response => {
            const teacherData = response.data.data;
            setReceiver(teacherData);
            setBranch(teacherData.branch_id)
        })
        .catch(error => console.error('Error fetching teacher list:', error));
    }, [user.username]);

    const handleSelectItem = (item) => {
        setSelectedItem(item);
        setAmount(''); // Reset amount
        setShowInventoryPopup(false);
    };

    const handleAddItem = () => {
        if (selectedItem && amount) {
        setItems([...items, { ...selectedItem, amount }]);
        setSelectedItem(null);
        setAmount('');
        }
    };

    const handleSubmit = async () => {
        if (!receiver) {
            alert('Receiver must be selected before submitting.');
            return;
        }

        const confirmation = window.confirm('Are you sure you want to proceed with this action?');
        if (!confirmation) {
            return;
        }
    
        // Mempersiapkan data untuk dikirim
        const transferData = {
            data: {
                transferData: {
                    teacher_id: receiver.teacher_id, // Menggunakan teacher_id dari receiver
                    branch_id: branch,
                    transferList: items.map(item => ({
                        inventory_id: item.inventory_id,
                        amount: item.amount
                    })),
                },
            },
        };
    
        try {
            const response = await api.post('/inventory/bookRequestSave', transferData); 
            const successMessage = response.data.message;
            console.log(successMessage);
            setItems([]);
            setReceiver(null);
            setBranch('');
            navigate('/success', { state: { message: successMessage } });
            
        } catch (error) {
            console.error('Error submitting data:', error);
            console.error('Error adding/updating teacher:', error);            
            navigate('/error', { state: { message: 'Please ask to administrator!' } });
        }
    };
  
    const handleDeleteItem = (index) => {
        const newItems = items.filter((_, i) => i !== index);
        setItems(newItems);
    };

  return (
    <div className="transfer-inventory-page">
        <div className="page-title">Book Request</div>
        <div className="form-container">
            <div className="section">
                <div className="search-container">
                    <table>
                        <tbody>
                            <tr>
                                <td>
                                    <label>Item Name</label>
                                </td>
                                <td>
                                    <div className="input-container">
                                        <input type="text" value={selectedItem ? selectedItem.item_name : ''} readOnly />
                                        <BsFiles className="icon" onClick={() => setShowInventoryPopup(true)} />
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <label>Item Type</label>
                                </td>
                                <td>
                                    <input type="text" value={selectedItem ? selectedItem.item_type : ''} readOnly />
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <label>Amount</label>   
                                </td>
                                <td>
                                    <input
                                    type="number"
                                    value={amount}
                                    onChange={(e) => setAmount(e.target.value)}
                                    max={selectedItem ? selectedItem.central_stock : 0}
                                    />
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <label>Branch</label>
                                </td>
                                <td>
                                    <select value={branch} onChange={(e) => setBranch(e.target.value)} disabled>
                                        <option value="">Select Branch</option>
                                        {branchList.map(branch => (
                                            <option key={branch.id} value={branch.id}>
                                                {branch.name}
                                            </option>
                                        ))}
                                        
                                    </select>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <label>Receiver</label>
                                </td>
                                <td>
                                    <div className="input-container">
                                    <input type="text" value={receiver ? receiver.teacher_name : ''} readOnly />
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td colSpan="2">
                                    <button onClick={handleAddItem}>Add</button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div className="section">
                <div className="inventory-list">
                    <table>
                        <thead>
                            <tr>
                                <th class="no-column">No</th>
                                <th>Item Name</th>
                                <th>Item Type</th>
                                <th>Amount</th>
                                <th>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {items.map((item, index) => (
                                <tr key={index}>
                                <td>{index + 1}</td>
                                <td>{item.item_name}</td>
                                <td>{item.item_type}</td>
                                <td>{item.amount}</td>
                                <td>
                                    <MdDelete className="icon" onClick={() => handleDeleteItem(index)} />  
                                </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
                <div className="search-container">
                    <button className="profile-button" onClick={handleSubmit}>Request</button>
                </div>
            </div>
        </div>
        {showInventoryPopup && (
            <InventoryListPopup onSelectItem={handleSelectItem} onClose={() => setShowInventoryPopup(false)} />
        )}
    </div>
  );
};

export default StockTransferPage;
